/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { Form, Formik } from 'formik';
import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import CheckBox from 'components/Form/CheckBox';
import { Row, Col } from 'components/Grid';

import { FitinsurAPI, MessageCenter } from 'utils';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Icon from 'components/Icon';
import { FontWeight } from 'components/Text';
import Colors from 'constants/Colors';
import { LostCancelButton } from 'components/index';
import {
  ButtonContent,
  Text,
  Scrollbox,
  Line,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  InlineLabel,
} from './styles';
import Loader from 'components/Loader/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import FormSection from 'components/FormSection';
import ModalMASConfirmation from './ModalMAS';
import * as yup from 'yup';
import { useHeaderNbi, useMarketsResponse, useListMarkets, useAddQuoteQuestionnaireMas } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService'


export default function SelectMarkets(props) {

  const [summary, setSummary] = useState({});
  const [sortList, setSortList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [data, setData] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState([]);
  const [isMAS, setIsMAS] = useState(false);
  const [isNewYork, setIsNewYork] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [attachmentFiles, setAttachmentFiles] = useState([]);
  const [previousItems, setPreviousItems] = useState([]);
  const [currentExternalBroker, setCurrentExternalBroker] = useState(null);
  const [idDomainStatusNBI, setIdDomainStatusNBI] = useState(null);
  const [isMasNewYork, setIsMasNewYork] = useState(false);
  const [hasSingapore, setHasSingapore] = useState(false);
  const [handleSingapore, setHandleSingapore] = useState(false);

  const formikRef = useRef();
  const [filter, setFilter] = useState(
    {
      key: null,
      direction: null,
    }
  );
  const coluns = [
    {
      title: "INSURER",
      value: "nmInsurer"
    },
    {
      title: "",
      value: ""
    },
    {
      title: "MAXIMUM LIMIT (USD)",
      value: "maxLimit"
    },
    {
      title: "MAXIMUM TENOR (YEARS)",
      value: "maxTenorDays"
    },
    {
      title: "APPROVED",
      value: "ndaStatus"
    },
    {
      title: "RATING",
      value: "rating"
    },
    {
      title: "SELECT",
      value: "select"
    },
  ];

  const history = useHistory();
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useMarketsResponseData,
    loading: useMarketsResponseLoading,
    error: useMarketsResponseError,
    status: useMarketsResponseStatus,
    request: useMarketsResponseRequest,
  } = useMarketsResponse(props.match.params.idOperation);

  const {
    data: useListMarketsData,
    loading: useListMarketsLoading,
    error: useListMarketsError,
    status: useListMarketsStatus,
    request: useListMarketsRequest,
  } = useListMarkets(props.match.params.idOperation);

  const {
    data: useAddQuoteQuestionnaireMasData,
    loading: useAddQuoteQuestionnaireMasLoading,
    error: useAddQuoteQuestionnaireMasError,
    status: useAddQuoteQuestionnaireMasStatus,
    request: useAddQuoteQuestionnaireMasRequest,
  } = useAddQuoteQuestionnaireMas();

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useMarketsResponseLoading || useListMarketsLoading || useAddQuoteQuestionnaireMasLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useMarketsResponseLoading, useListMarketsLoading, useAddQuoteQuestionnaireMasLoading]);

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      if (data.ret_code != 200) {
        mc.error(data.ret_msg_details);
        history.goBack();
        return;
      }
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
        idProduct: data.ret_value.idProduct
      });
      setEndorsmentType(data.ret_value.endorsmentType);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function getOperationInfo() {
    useOperationInfoRequest().then(({ data: response }) => {
      setIsMAS(response.isMas);
      setIsNewYork(response.isNewYork);
      setHasSingapore(response.hasSingapore);

      if (response.isMas || response.isNewYork) {
        getQuestionnaire(response.isMas, response?.idProduct);
      } else {
        handleList(null);
      }

      handleGetNbiStatus();
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  function getQuestionnaire(isMasParam, idProduct) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    const idQuestions = isMasParam ? [139, 182, 710] : [139, 182, 1160]
    let questions = null;

    fitinsur.requestGenericQuestions(props.match.params.idOperation, idQuestions, idProduct)
      .then(response => response.json()).then(data => {
        if (data.ret_code === 200) {
          const masExternalQuestion = data.ret_value.questions.find(v => v.idQuestion === 710);
          const offshoreQuestion = data.ret_value.questions.find(v => v.idQuestion === 1160);

          const questionsValidate = [710, 1160];
          questions = data.ret_value.questions.map(question => {
            if (question.idQuestion === 182 && question.answer) {
              try {
                setCurrentExternalBroker(JSON.parse(question.answer))
              } catch (e) {
              }
            }

            return {
              ...question,
              idDomainQuestion: question.idQuestion === 139 ? 276 : question.idDomainQuestion,
              behaviorObject: {
                ...question.behaviorObject,
                sectionName: 'BROKING',
                searchQueryId: question.idQuestion === 139 ? 'fitGetCompanyIndividualPerson' : question.behaviorObject.searchQueryId,
                isRequired: !questionsValidate.includes(question.idQuestion) ? true : false
              },
              visibleQuestion: 1,
              disabled: ((masExternalQuestion?.answer && masExternalQuestion?.answer === "YES") || (offshoreQuestion?.answer && offshoreQuestion?.answer === "YES"))
            }
          });

          setQuestionnaire(questions);
          setQuestionnaireAnswers(questions);
        } else {
          mc.error(data.ret_msg_details);
        }

        handleList(questions);
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostSubmit - Error:', error);
      });
  };

  const handleCreateMasQuestionnaire = (handleCreateMasQuestionnaire) => {
    useAddQuoteQuestionnaireMasRequest({ idOperation: props.match.params.idOperation, questionnaire: handleCreateMasQuestionnaire || questionnaireAnswers, file: attachmentFiles }, null).then(({ data }) => {
      if (data.ret_code != 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      getQuestionnaire(isMAS, summary?.idProduct);
      setShowModal(false);
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleCreateMasQuestionnaire.name}\n` + error);
      console.error('fitPostDocument - Error:', error);
    });
  }

  const buildValidation = () => {
    const validationSchema = {};

    for (const question of questionnaireAnswers) {
      validationSchema[question.key] = !question.answer && question.behaviorObject.isRequired
        ? yup.string().required("* Required field")
        : yup.string().notRequired().nullable();
    }
    return yup.object().shape(validationSchema)
  }

  function handleSubmit() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    let list = selectedItems;

    fitinsur.requestSelectMarkets(props.match.params.idOperation, list)
      .then(response => response.json()).then(data => {
        if (data.ret_code === 200) {
          loading.stop();
          history.push(`/broking/contacts-selection/${props.match.params.idOperation}`, { idProduct: props?.location?.state?.idProduct });

        } else {
          mc.error(data.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostSubmit - Error:', error);
      });
  };

  function handleSortList(key) {
    let direction = 'asc';
    if (filter.key === key && filter.direction === 'asc') {
      direction = 'desc';
    };
    setFilter({ key: key, direction: direction });
  };

  function handleSelect(e, ids = []) {
    if (ids.length >= 1) {
      setSelectedItems([...selectedItems, ...ids]);
      return
    }
    const alreadySelected = selectedItems.findIndex((item) => item === e.ID_PERSON);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item !== e.ID_PERSON);
      setSelectedItems(filteredItems);
    } else {
      if (e) {
        setSelectedItems([...selectedItems, e.ID_PERSON]);
      }

    };
  };

  function handleBack() {
    history.goBack();
  }

  useMemo(() => {
    setSortList(data);
    if (filter !== null) {
      sortList.sort((a, b) => {
        if (a[filter.key] < b[filter.key]) {
          return filter.direction === 'asc' ? -1 : 1;
        } else if (a[filter.key] > b[filter.key]) {
          return filter.direction === 'asc' ? 1 : -1;
        }
        return 0;
      })
    } else {
      return;
    }

  }, [filter, data]);


  function handleGetNbiStatus(queryString) {
    useMarketsResponseRequest().then(({ data }) => {
      if (data.ret_code != 200) {
        return;
      }
      setIdDomainStatusNBI(data.ret_value.idDomainStatusNBI)
    })
  };


  async function handleList(questionnaire) {
    let paramsRequest = null;
    if (questionnaire) {
      const findedMasQuestion = questionnaire.find(questionnaire => questionnaire.idQuestion === 710);
      const findedOffshoreNyQuestion = questionnaire.find(questionnaire => questionnaire.idQuestion === 1160);

      if (findedMasQuestion && !findedMasQuestion.answer) paramsRequest = { idQuestion: 710, idAnswerOptions: [4689] }
      if (findedOffshoreNyQuestion && !findedOffshoreNyQuestion.answer) paramsRequest = { idQuestion: 1160, idAnswerOptions: [6067] }
    }

    useListMarketsRequest(null, { replaceQuestionAnswer: paramsRequest ? JSON.stringify({ ...paramsRequest }) : paramsRequest }).then(({ data: res }) => {
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        history.goBack();
        return;
      }

      let ids = [];
      res.ret_value.forEach((e) => {
        if ("existInsurer" in e) {
          if (e.existInsurer) {

            ids.push(e.ID_PERSON)

          }
        }
      })
      handleSelect(null, ids);
      setPreviousItems(ids);
      setData(res.ret_value)
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleList.name}\n` + error);
        console.error('fitPostList - Error:', error);
      });
  };

  useEffect(() => {
    handleSummary();
    getOperationInfo();
  }, [])

  useEffect(() => {
    setSortList(data);
  }, [data])

  useEffect(() => {
    if (isMAS == true || isNewYork == true)
      setIsMasNewYork(true)
  }, [isMAS, isNewYork])

  useEffect(() => {
    if (isNewYork) {
      handleCreateMasQuestionnaire()
    }
  }, [handleSingapore])

  const handleMAS = async (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    if (answer.dsAnswerOption === 'YES') {
      if (hasSingapore) {
        buildValidation().validate().then(() => {
          setShowModal(true);
        }).catch((e) => {
          console.log('validation error', e)
          mc.error('Please fill in all required fields.')

          setFilteredQuestionnaire(filteredQuestionnaire.map(v => v.key === question.key ? ({ ...v, idAnswerOption: null, answer: null, answerJson: null }) : v))
          setFieldValue && setFieldValue(question.key, "NO");
        });
      } else {
        if (isNewYork) {
          setHandleSingapore(true);
        } else {
          buildValidation().validate().then(() => {
            handleCreateMasQuestionnaire(filteredQuestionnaire);
          }).catch((e) => {
            console.log('validation error', e)
            mc.error('Please fill in all required fields.')

            setFilteredQuestionnaire(filteredQuestionnaire.map(v => v.key === question.key ? ({ ...v, idAnswerOption: null, answer: null, answerJson: null }) : v))
            setFieldValue && setFieldValue(question.key, "NO");
          });
        }
      }
    }
  }

  const renderIsMasOffshoreNy = () => {
    return (
      <ContentCard title='&nbsp;'>
        <Formik
          innerRef={formikRef}
          initialValues={{}}
          validationSchema={buildValidation()}
          enableReinitialize={true}
          render={({ values, setFieldValue }) => (
            <Form>
              <FormSection
                sectionName="BROKING"
                questionnaire={questionnaire}
                values={values}
                setFieldValue={setFieldValue}
                formikRef={formikRef}
                externalFormCurrentClient={currentExternalBroker}
                onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                  if (question.idQuestion === 182 && (answer?.id || answer?.idPerson)) {
                    setCurrentExternalBroker(answer);
                  }
                  console.log("filteredQuestionnaire", filteredQuestionnaire)
                  setQuestionnaireAnswers(filteredQuestionnaire);
                  setTimeout(() => {
                    handleMAS(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);
                  }, 300)
                }}
                isSelectMarketsScreen
              />
            </Form>
          )}>
        </Formik>
      </ContentCard>
    )
  }

  const changeAttachmentFiles = state => setAttachmentFiles(state);

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      {console.log(summary)}
      <Scrollbox>
        <BrokingSummary data={summary} />
        {((isMAS || isNewYork) && questionnaire.length > 0) && renderIsMasOffshoreNy()}
        {showModal && hasSingapore && <ModalMASConfirmation
          idOperation={summary.idOperation}
          show={showModal && hasSingapore}
          changeAttachmentFiles={changeAttachmentFiles}
          onConfirm={() => {
            buildValidation().validate().then(() => handleCreateMasQuestionnaire()).catch((e) => {
              console.log('validation error', e)
              mc.error('Please fill in all required fields.')
            });
          }}
          onCancel={() => {
            setShowModal(false)
            getQuestionnaire(isMAS, summary?.idProduct)
          }} />
        }
        <ContentCard title={endorsmentType && endorsmentType === 'risk_changes' ? "Risk & Market Changes / SELECT MARKETS" : "SELECT MARKETS"} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

          <Table>
            <TableHead>
              <TableRow style={{ borderBottom: (!isMAS || !isNewYork) ? '2px solid #E0E0E0' : 'unset' }}>
                {coluns.map((column, index) =>
                  <TableHeader key={index}>
                    <Text onClick={() => handleSortList(column.value)}>
                      {column.title}
                    </Text>

                    {filter.key === column.value && filter.direction === "asc" ?
                      <Icon name="arrowUp" className="icon-arrowUp" />
                      : <Icon name="arrowDown" className="arrowDown" />}
                  </TableHeader>
                )}
              </TableRow>
            </TableHead>

            <div style={{ marginTop: '15px' }} />
            <TableBody style={{ marginTop: '15px' }}>
              {!sortList ? "" : sortList.map((item, index) => {
                if (previousItems.includes(item.ID_PERSON)) return <></>;

                return (
                  <>
                    <TableRow key={index} style={{ marginTop: "10px", fontWeight: `${FontWeight.SemiBold}`, color: `${Colors.GRAY[0]}` }} index={index}>
                      <TableCollum>
                        <InlineLabel>INSURER</InlineLabel>
                        <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>
                          {item.PERSON_FIRST_NAME}
                          {item.showChildRow ?
                            <Icon name={"arrowup-large"} onClick={() => setData(data.map(v => (item.ID_PERSON === v.ID_PERSON && item.PERSON_FIRST_NAME === v.PERSON_FIRST_NAME ? { ...v, showChildRow: false } : v)))} style={{ marginLeft: '7px' }} />
                            :
                            <Icon name={"arrowdown-large"} onClick={() => setData(data.map(v => (item.ID_PERSON === v.ID_PERSON && item.PERSON_FIRST_NAME === v.PERSON_FIRST_NAME ? { ...v, showChildRow: true } : v)))} style={{ marginLeft: '7px' }} />
                          }</Text>
                      </TableCollum>

                      <TableCollum>
                        <InlineLabel></InlineLabel>
                        {!isMasNewYork && <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{item.coverages[0]?.coverageName}</Text>}
                      </TableCollum>

                      <TableCollum>
                        <InlineLabel>MAXIMUM LIMIT (USD)</InlineLabel>
                        {!isMasNewYork && <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{item.coverages[0]?.maxLimit}</Text>}
                      </TableCollum>

                      <TableCollum>
                        <InlineLabel>MAXIMUM TENOR (YEARS)</InlineLabel>
                        {!isMasNewYork && <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{(parseInt(item.coverages[0]?.maxTenorYears || 0)).toFixed(0)}</Text>}
                      </TableCollum>

                      <TableCollum>
                        <InlineLabel>APPROVED</InlineLabel>
                        <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{item.ndaStatus ? "YES" : "NO"}</Text>
                      </TableCollum>

                      <TableCollum>
                        <InlineLabel>RATING</InlineLabel>
                        <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{item.ratingMarket ? item.ratingMarket.description : "-"}</Text>
                      </TableCollum>

                      <TableCollum style={{ textAlign: 'center' }}>
                        <InlineLabel>SELECT</InlineLabel>
                        <label>
                          <CheckBox
                            checked={selectedItems.includes(item.ID_PERSON) ? true : false}
                            onChange={() => { handleSelect(item) }}
                          />
                        </label>
                      </TableCollum>
                    </TableRow>


                    {(isMAS || isNewYork) && item.showChildRow &&
                      item.coverages && item.coverages.map(coverage => (
                        <TableRow key={index} style={{ border: 'none', marginTop: "10px", fontWeight: `${FontWeight.SemiBold}`, color: `${Colors.GRAY[0]}` }}>
                          <TableCollum>
                            <InlineLabel></InlineLabel>
                            <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}></Text>
                          </TableCollum>
                          <TableCollum>
                            <InlineLabel>COVERAGE NAME</InlineLabel>
                            <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{coverage.coverageName}</Text>
                          </TableCollum>
                          <TableCollum>
                            <InlineLabel>MAXIMUM LIMIT (USD)</InlineLabel>
                            <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{coverage.maxLimit}</Text>
                          </TableCollum>
                          <TableCollum>
                            <InlineLabel>MAXIMUM TENOR (YEARS)</InlineLabel>
                            <Text style={{ fontSize: '14px', textTransform: 'unset', color: `${Colors.GRAY[0]}` }}>{(parseInt(coverage.maxTenorYears || 0)).toFixed(0)}</Text>
                          </TableCollum>
                        </TableRow>
                      ))
                    }
                  </>
                )
              })}
            </TableBody>
          </Table>
          <ButtonContainer>
            <Button forth onClick={() => handleBack()}>&lt; Back</Button>
            <RenderButtons idOperation={props.match?.params?.idOperation}>
              <ButtonContent>
                <div style={{ marginTop: "5px" }}>
                  <LostCancelButton idOperation={props.match?.params?.idOperation} />
                </div>
                <Button
                  primary
                  type="submit"
                  onClick={() => handleSubmit()} style={{ marginLeft: "10px", marginTop: "5px" }}
                  disabled={idDomainStatusNBI === 19}
                >
                  SUBMIT
                </Button>
              </ButtonContent>
            </RenderButtons>
          </ButtonContainer>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard>
      </Scrollbox >
    </Layout >
  )
}
